package com.evoapps.evoshift.ui.util

import evoshift.composeapp.generated.resources.kiosk_error_pin_disabled
import evoshift.composeapp.generated.resources.kiosk_error_not_on_break
import evoshift.composeapp.generated.resources.kiosk_error_on_break
import evoshift.composeapp.generated.resources.kiosk_error_too_many_breaks
import com.evoapps.evoshift.domain.model.KioskException
import evoshift.composeapp.generated.resources.Res
import evoshift.composeapp.generated.resources.checklist_note_required
import evoshift.composeapp.generated.resources.kiosk_error_no_checklist
import evoshift.composeapp.generated.resources.error_generic
import evoshift.composeapp.generated.resources.kiosk_error_code
import evoshift.composeapp.generated.resources.kiosk_error_device_time
import evoshift.composeapp.generated.resources.kiosk_error_done
import evoshift.composeapp.generated.resources.kiosk_error_locked
import evoshift.composeapp.generated.resources.kiosk_error_no_pin
import evoshift.composeapp.generated.resources.kiosk_error_no_shift
import evoshift.composeapp.generated.resources.kiosk_error_not_clocked_in
import evoshift.composeapp.generated.resources.kiosk_error_not_manager
import evoshift.composeapp.generated.resources.kiosk_error_not_on_team
import evoshift.composeapp.generated.resources.kiosk_error_not_your_shift
import evoshift.composeapp.generated.resources.kiosk_error_pin_shape
import evoshift.composeapp.generated.resources.kiosk_error_plan_ended
import evoshift.composeapp.generated.resources.kiosk_error_qr_disabled
import evoshift.composeapp.generated.resources.kiosk_error_qr_expired
import evoshift.composeapp.generated.resources.kiosk_error_qr_invalid
import evoshift.composeapp.generated.resources.kiosk_error_qr_used
import evoshift.composeapp.generated.resources.kiosk_error_revoked
import evoshift.composeapp.generated.resources.kiosk_error_wrong_pin

/** SH-107: the clock-in tablet's refusals, worded for the person at the tablet. */
fun KioskException.kioskText(): UiText = when (reason) {
    KioskException.Reason.WRONG_PIN -> UiText.Resource(Res.string.kiosk_error_wrong_pin, attemptsLeft ?: 0)
    KioskException.Reason.LOCKED -> UiText.Resource(Res.string.kiosk_error_locked, retryAfterMinutes ?: 15)
    KioskException.Reason.NO_PIN -> UiText.Resource(Res.string.kiosk_error_no_pin)
    KioskException.Reason.PIN_SHAPE -> UiText.Resource(Res.string.kiosk_error_pin_shape)
    KioskException.Reason.PIN_DISABLED -> UiText.Resource(Res.string.kiosk_error_pin_disabled)
    KioskException.Reason.NO_SHIFT_NOW -> UiText.Resource(Res.string.kiosk_error_no_shift)
    KioskException.Reason.ALREADY_DONE -> UiText.Resource(Res.string.kiosk_error_done)
    KioskException.Reason.NOT_CLOCKED_IN -> UiText.Resource(Res.string.kiosk_error_not_clocked_in)
    KioskException.Reason.NOT_YOUR_SHIFT -> UiText.Resource(Res.string.kiosk_error_not_your_shift)
    KioskException.Reason.NOT_ON_TEAM -> UiText.Resource(Res.string.kiosk_error_not_on_team)
    KioskException.Reason.REVOKED -> UiText.Resource(Res.string.kiosk_error_revoked)
    KioskException.Reason.CODE_INVALID -> UiText.Resource(Res.string.kiosk_error_code)
    KioskException.Reason.PLAN_ENDED -> UiText.Resource(Res.string.kiosk_error_plan_ended)
    KioskException.Reason.NOT_A_MANAGER -> UiText.Resource(Res.string.kiosk_error_not_manager)
    KioskException.Reason.BAD_DEVICE_TIME -> UiText.Resource(Res.string.kiosk_error_device_time)
    KioskException.Reason.QR_INVALID -> UiText.Resource(Res.string.kiosk_error_qr_invalid)
    KioskException.Reason.QR_EXPIRED -> UiText.Resource(Res.string.kiosk_error_qr_expired)
    KioskException.Reason.QR_USED -> UiText.Resource(Res.string.kiosk_error_qr_used)
    KioskException.Reason.QR_DISABLED -> UiText.Resource(Res.string.kiosk_error_qr_disabled)
    KioskException.Reason.ALREADY_ON_BREAK -> UiText.Resource(Res.string.kiosk_error_on_break)
    KioskException.Reason.NOT_ON_BREAK -> UiText.Resource(Res.string.kiosk_error_not_on_break)
    KioskException.Reason.TOO_MANY_BREAKS -> UiText.Resource(Res.string.kiosk_error_too_many_breaks)
    KioskException.Reason.NOTE_REQUIRED -> UiText.Resource(Res.string.checklist_note_required)
    KioskException.Reason.NO_CHECKLIST -> UiText.Resource(Res.string.kiosk_error_no_checklist)
    KioskException.Reason.UNKNOWN -> UiText.Resource(Res.string.error_generic)
}
